import React from "react";

export const IconCaution: React.FC = () => {
	return (
		<svg
			width="24"
			height="25"
			viewBox="0 0 24 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M11.9999 9.92857V13.6786M2.69694 17.0546C1.83094 18.5546 2.91394 20.4286 4.64494 20.4286H19.3549C21.0849 20.4286 22.1679 18.5546 21.3029 17.0546L13.9489 4.30657C13.0829 2.80657 10.9169 2.80657 10.0509 4.30657L2.69694 17.0546ZM11.9999 16.6786H12.0069V16.6866H11.9999V16.6786Z"
				stroke="#F03E3E"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
};
